import React, {Component, forwardRef} from 'react';
import {Col, Row, Table} from "reactstrap";
import Moment from "react-moment";
import 'moment/locale/fr';
import './Products.css'
import UpdateModalForm from "./modals/UpdateProductModal";
import {ChevronDown, ChevronUp, Edit2, Power, Shuffle, Trash} from "react-feather";
import DeleteProductRatingModal from "./modals/DeleteProductRatingModal";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import {Badge, FormControl, OverlayTrigger, Tooltip} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Logout from "./Logout";
import {ReactSortable} from "react-sortablejs";
import Loader from "./Loader";
import { apiFetch, API, getMarket } from "../services/api";


function getProductRatings() {
    // La liste est filtrée par marché (apiFetch ajoute lang). La langue d'un avis
    // = celle écrite par le client, on ne la modifie jamais à l'écriture.
    return apiFetch(API.back + '/product-ratings', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function updateState(product, checked) {
    product.approved = checked
    return apiFetch(API.back + '/product-rating', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(product)
    }).then()
        .catch( err =>
            console.log(err)
        )
}

export class ProductRatingsList extends Component{
    constructor(props) {
        super(props);
        this.state = {
            productRatings: null,
            errors: "",
            loading: true,
            selectedRating: null
        }
    }

    async componentDidMount() {
        await getProductRatings().then(data => {
            this.setState({ productRatings: data, errors : "", loading: false })
        }).catch(err =>{
            //localStorage.removeItem('token');
            //window.location.href="/";
            this.setState({errors: "error while getting products"})
            }
        );
    };

    render(){
        return(
            <div className="products-list">
                {this.state.productRatings == null ? <p> Chargement ...</p> :

                <div>
                    <Col sm={8} className="products-buttons">
                        <span>Nombre d'avis produits : {this.state.productRatings.length}</span>
                    </Col>
                    <Table responsive>

                        <tbody>

                        

                        {(this.state.loading !== true)
                            ?
                            <Table responsive>
                                <thead>
                                <tr>
                                    <th>Produit</th>
                                    <th>Note</th>
                                    <th>Avis</th>
                                    <th>Nom</th>
                                    <th>Email</th>
                                    <th>Date</th>
                                    <th></th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.productRatings.map(rating => (
                                    <tr>
                                        <td>{rating.productName}</td>
                                        <td>{rating.stars}</td>
                                        <td>{(rating.translations && rating.translations[getMarket()]) ? rating.translations[getMarket()] : rating.message}</td>
                                        <td>{rating.name}</td>
                                        <td>{rating.email}</td>
                                        <td><Moment to={rating.createdDate}>{Date.now()}</Moment></td>
                                        <td><BootstrapSwitchButton
                                            checked={rating.approved}
                                            onlabel='oui'
                                            onstyle='success'
                                            offlabel='non'
                                            offstyle='danger'
                                            size='xs'
                                            onChange={(checked: boolean) => {
                                                updateState(rating, checked)
                                            }}
                                        /></td>
                                        <td className="table-action">
                                            <Trash className="align-middle" size={18}
                                                   onClick={(e) => this.setState({isDelete: true, selectedRating: rating})}/>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </Table>
                        :
                        null }
                        </tbody>
                    </Table>
                </div>
                }
                { this.state.isDelete ?
                    <DeleteProductRatingModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedRating}
                        selectedCategory="product-rating"
                    />
                    :
                    null
                }
            </div>
        );
    }
}